import { Button } from "components/Button/Button";
import { InputComponentProps } from "components/Form/components/InputComponentProps";
import { IconCollection } from "components/Icon/IconCollection";
import Tooltip from "components/Tooltip/Tooltip";
import styles from "./CopyToClipboard.module.scss";

export interface CopyToClipboardProps {
    identifier: string;
    input: InputComponentProps<string>;
    attributes?: any; // TODO consider improvement
    textToCopy: string;
    isReadonly?: boolean;
}

export const CopyToClipboard = ({
    identifier,
    input,
    attributes,
    textToCopy,
    isReadonly,
}: CopyToClipboardProps) => {
    const handleClick = () => {
        navigator.clipboard.writeText(textToCopy);
    };
    const handleFocus = (event) => event.target.select();

    return (
        <div className={styles.copyToClipboardWrapper}>
            <input
                {...attributes}
                {...input}
                id={`${identifier}`}
                aria-label={`${identifier}`}
                type="text"
                className="input__field"
                onFocus={handleFocus}
                readOnly={isReadonly}
            />
            <Tooltip overlay="Copy">
                <Button
                    size="small"
                    icon={IconCollection.contentCopy}
                    onClick={handleClick}
                    variation="clear"
                />
            </Tooltip>
        </div>
    );
};
